const Globe = ({ className = "", color }: { className?: string; color: string }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    role="img"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <circle data-name="layer2" cx="31.999" cy="32" r="30" fill={color}></circle>
    <path data-name="opacity" d="M32 62V2a30 30 0 0 0 0 60z" fill="#000064" opacity=".15"></path>
    <path
      data-name="layer1"
      d="M59.908 43H48.041a59.3 59.3 0 0 0 1.017-11 59.3 59.3 0 0 0-1.017-11h11.867a30.063 30.063 0 0 0-.865-2H47.622C46.083 12.283 43.4 6.671 40.095 3.115a29.82 29.82 0 0 0-4-.829c4.1 2.57 7.586 8.814 9.467 16.714H33V2.026C32.667 2.014 32.335 2 32 2s-.666.014-1 .026V19H18.441c1.88-7.9 5.368-14.146 9.467-16.715a29.734 29.734 0 0 0-4 .828C20.6 6.669 17.921 12.281 16.382 19H4.954a28.57 28.57 0 0 0-.865 2h11.874a60.02 60.02 0 0 0 0 22H4.089c.268.678.551 1.347.865 2h11.428c1.539 6.719 4.219 12.332 7.528 15.888a29.858 29.858 0 0 0 4 .828C23.809 59.146 20.322 52.9 18.441 45H31v16.975c.332.011.663.025 1 .025s.668-.014 1-.025V45h12.563c-1.881 7.9-5.368 14.145-9.467 16.715a29.852 29.852 0 0 0 4-.829C43.4 57.329 46.083 51.717 47.622 45h11.421c.314-.653.598-1.322.865-2zM31 43H18.009a57.446 57.446 0 0 1 0-22H31zm14.994 0H33V21h12.995a57.17 57.17 0 0 1 1.063 11 57.166 57.166 0 0 1-1.063 11z"
      fill="white"
      opacity="0.9"
    ></path>
  </svg>
);

export default Globe;
